export default "__VITE_ASSET__OahaCbtn__"